import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-grid.css';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

// axios.defaults.baseURL = 'http://pkapi.dev.com';

Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
